<template>
  <div :class="[ 'c-multi-select', { '-validation': !!validation, '-label-left': labelLeft } ]">
    <c-select
      class="select"
      :value="computedValue"
      :validation="validation"
      :options="availableOptions"
      :track-by="trackBy"
      :display-by="displayBy"
      :label-left="labelLeft"
      v-bind="getAttrs($attrs)"
      @input="onInput"
      @add-option="$emit('add-option')"
      @click:item-option="$emit('click:item-option', $event)"
    />

    <c-multi-select-item-list
      v-if="(computedValue || []).length"
      class="selected"
      :items="computedValue"
      :display-by="displayBy"
      v-bind="$attrs"
      @remove="handleRemove"
    />
  </div>
</template>

<script>
import CSelect from '@convenia/components/CSelect/index.vue'
import CMultiSelectItemList from '@convenia/components/CMultiSelectItemList/index.vue'

import CommonMixin from './fragments/CommonMixin'

export default {
  name: 'CMultiSelect',

  components: {
    CSelect,
    CMultiSelectItemList
  },

  mixins: [ CommonMixin ],

  methods: {
    getAttrs (attrs) {
      return {
        ...attrs,
        disabled: (attrs.disabled || !this.availableOptions.length) && !this.habilityEmptyOption,
        habilityEmptyOption: this.habilityEmptyOption,
        keepAllOptionsAvailable: this.keepAllOptionsAvailable
      }
    },

    handleRemove (item) {
      this.$emit('remove', item)
    },
  }
}
</script>

<style lang="scss">

.c-multi-select {
  display: flex;
  flex-direction: column;
}
</style>
